import { configureStore as _configureStore } from '@reduxjs/toolkit';
import thunk from 'redux-thunk';
import { UsageTrackerUtils } from 'feature-unboxing-common';
import { rootReducer } from '../reducers';
const {
  trackerMiddleware
} = UsageTrackerUtils;
export const configureStore = (initialState = {}) => {
  const store = _configureStore({
    reducer: rootReducer,
    preloadedState: initialState,
    middleware: [thunk, trackerMiddleware('livechat-builder-ui')]
  });
  return store;
};